/**
 * 商品マスタ、商品企画マスタから呼び出される際に用いる受渡情報VO
 *
 * @export KYMW0500InputModel
 * @class KYMW0500InputModel
 */
export class KYMW0500InputModel {
  /** 処理区分(2：商品企画マスタから起動) */
  public processDiv: string = <string>'';

  /** 編集モード */
  public editMode: boolean = <boolean>false;

  /** 受注コード */
  public orderCode: string = <string>'';

  /** 媒体区分 */
  public mediumType: string = <string>'';

  /** 代表商品コード */
  public mainPCode: string = <string>'';
}

